import { useMutation, useQueries, useQuery } from "@tanstack/react-query";

export default class QueryFn {
  useFetch = (key: string, functionReceived: Function, disable?: boolean) =>
    useQuery({
      queryKey: [key],
      queryFn: async (value?: any) => await functionReceived(value),
      enabled: disable,
      retry: 0,
      refetchOnMount: "always",
      refetchOnWindowFocus: false,
    });

  useMutate = (key: string, functionReceived: Function) =>
    useMutation({
      mutationKey: [key],
      mutationFn: async (params?: any) => await functionReceived(params),
      retry: false,
    });

  useFetchMultiple = (queriesArr: { key: string; fn: Function }[]) =>
    useQueries({
      // eslint-disable-next-line
      queries: <any>queriesArr?.map((elem: any) => {
        return {
          queryKey: [elem.key],
          queryFn: async (value?: any) => elem.fn(value),
          retry: 0,
          refetchOnWindowFocus: false,
          refetchOnMount: "always",
        };
      }),
    });
}
